const clockToMinutes = (value) => {
  const match = String(value || "").trim().match(/^(\d{1,2}):(\d{2})/);

  if (!match) {
    return Number.MAX_SAFE_INTEGER;
  }

  return Number(match[1]) * 60 + Number(match[2]);
};

const getSlotSortValue = (slot = {}) => {
  if (Number.isFinite(slot.sortValue)) {
    return slot.sortValue;
  }

  if (Number.isInteger(Number(slot.hour))) {
    return Number(slot.hour) * 60;
  }

  if (slot.from) {
    return clockToMinutes(slot.from);
  }

  if (slot.time) {
    return clockToMinutes(String(slot.time).split(" - ")[0]);
  }

  return Number.MAX_SAFE_INTEGER;
};

export const sortBoatTimeSlots = (slots = []) =>
  [...slots].sort((a, b) => {
    const diff = getSlotSortValue(a) - getSlotSortValue(b);

    if (diff !== 0) {
      return diff;
    }

    return String(a.time || "").localeCompare(String(b.time || ""));
  });
